// Configuración de AdSense para Anthony Cazares Blog
export const ADSENSE_CONFIG = {
    // Publisher ID real
    publisherId: "ca-pub-5056187426552621",
    
    // Ad Slots - TODOS LOS AD UNIT IDS COMPLETADOS
    adSlots: {
        // Banner principal en home (Ad Unit #1 - CREADO)
        homeBanner: "3824155666",
        
        // Anuncio en artículos después de imagen (Ad Unit #2 - CREADO)
        inArticle: "8149595249",
        
        // Anuncio al final de artículos (Ad Unit #3 - CREADO)
        articleEnd: "4043647518",
        
        // Banner en página About (Ad Unit #4 - CREADO)
        aboutPage: "1991381007",
        
        // Sidebar (opcional para futuro)
        sidebar: "XXXXXXXXXX",
        
        // Banner en página Contact (opcional para futuro)
        contactPage: "XXXXXXXXXX"
    },
    
    // Configuración de Auto Ads (opcional)
    autoAds: {
        enabled: true,
        // Configuraciones adicionales de Auto Ads
    }
};

export default ADSENSE_CONFIG;